export const isTouchScreen = () =>
    typeof window !== 'undefined' && window.matchMedia('(pointer: coarse)').matches;
